class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.minOrderAmount = this.notification.getAttribute('data-min-order');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  updateFreeShippingBar(cartData, targetVal) {
    var cartTotal = (cartData.total_price / 100).toFixed(2);
    var cartItems = cartData.items;
    var minOrderAmount = parseInt(targetVal).toFixed(2);
    var progressBarContainer = document.querySelector('.free-shipping__wrapper');
    var progressBar = document.querySelector('.free-shippingThreshold__progress');
    var progressNum = document.querySelector('.free-shipping__num');
    var itemsWithFreeShipping = cartItems.filter(item => item.properties.freeShipping);

    if (itemsWithFreeShipping.length == cartItems.length) {
      progressBarContainer.classList.add('hidden');
    } else {
      progressBarContainer.classList.remove('hidden');
    }

    if (itemsWithFreeShipping.length) {
      let sum = 0;
      itemsWithFreeShipping.forEach(item => {
        sum += item.final_line_price;
      });
      sum = (sum / 100).toFixed(2);
      console.log(`[updateFreeShippingBar] sum: ${sum}`);
      cartTotal = cartTotal - sum;
    }

    console.log(`[calculateProgress] cart total: ${cartTotal} order threshold ${typeof minOrderAmount} ${minOrderAmount}`);
    
    var result = Math.round(100 * cartTotal / minOrderAmount);
    var amountRemaining = (minOrderAmount - cartTotal).toFixed(2);
    progressBar.setAttribute('style', `width: ${result}%`)
   
    if (amountRemaining <= 0) {
      document.querySelector('.free-shipping__success-msg').style.display = 'block';
      document.querySelector('.free-shipping__remaining-msg').style.display = 'none';
    } else {
      document.querySelector('.free-shipping__success-msg').style.display = 'none';
      document.querySelector('.free-shipping__remaining-msg').style.display = 'block';
    }
    progressNum.textContent = amountRemaining;
  };

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      console.log(`[renderContents] minOrderAmount ${this.minOrderAmount}`);
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();

      fetch('/cart/update.js')
        .then(response => response.json())
        .then(data => {
          this.updateFreeShippingBar(data, this.minOrderAmount);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
